<script>
import { VDataTable } from 'vuetify/lib'
import EDataFooter from './EDataFooter.vue'
import { getObjectValueByPath, getPrefixedScopedSlots, getPropertyFromItem } from 'vuetify/lib/util/helpers'
import { VIcon, VSimpleTable } from 'vuetify/lib/components'
import Row from 'vuetify/lib/components/VDataTable/Row'
import { mergeClasses } from 'vuetify/lib/util/mergeData'
import { ECheckbox } from '../index'
import { getSlot } from 'vuetify/lib/util/helpers'
import EDataTableHeader from './EDataTableHeader.vue'

import Loadable from '../../../mixins/loadable'

export default {
  name: 'EDataTable',
  extends: VDataTable,
  mixins: [Loadable],
  props: {
    // loaderHeight: {
    //   type: Number,
    //   default: 0,
    // },
    hideDefaultFooter: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    colspanAttrs() {
      return {
        colspan: this.headersLength || this.computedHeaders.length,
      }
    },
    // isMobile() {
    //   return false
    // },
    // isMobileCustom() {
    //   const { mobile, width, name, mobileBreakpoint } = this.$vuetify.breakpoint // Check if local mobileBreakpoint matches
    //   // the application's mobileBreakpoint
    //
    //   if (mobileBreakpoint === this.mobileBreakpoint) return mobile
    //   const mobileWidth = parseInt(this.mobileBreakpoint, 10)
    //   const isNumber = !isNaN(mobileWidth)
    //   return isNumber ? width < mobileWidth : name === this.mobileBreakpoint
    // },
  },
  methods: {
    genEmpty(originalItemsLength, filteredItemsLength) {
      if (originalItemsLength === 0 && this.loading) {
        const loading = this.$slots.loading || [this.genProgress()]
        return this.genEmptyWrapper(loading)
      } else if (originalItemsLength === 0) {
        const noData = this.$slots['no-data'] || this.$vuetify.lang.t(this.noDataText)
        return this.genEmptyWrapper(noData)
      } else if (filteredItemsLength === 0) {
        const noResults = this.$slots['no-results'] || this.$vuetify.lang.t(this.noResultsText)
        return this.genEmptyWrapper(noResults)
      }
      return null
    },
    genDefaultSimpleRow(item, index, classes = {}) {
      const scopedSlots = getPrefixedScopedSlots('item.', this.$scopedSlots)
      const data = this.createItemProps(item, index)

      if (this.showSelect) {
        const slot = scopedSlots['data-table-select']
        scopedSlots['data-table-select'] = slot
          ? () => slot({ ...data, isMobile: this.isMobile })
          : () => {
              return this.$createElement(ECheckbox, {
                staticClass: 'v-data-table__checkbox',
                props: {
                  value: data.isSelected,
                  disabled: !this.isSelectable(item),
                },
                on: {
                  change: (val) => data.select(val),
                },
              })
            }
      }

      if (this.showExpand) {
        const slot = scopedSlots['data-table-expand']
        scopedSlots['data-table-expand'] = slot
          ? () => slot(data)
          : () =>
              this.$createElement(
                VIcon,
                {
                  staticClass: 'v-data-table__expand-icon',
                  class: {
                    'v-data-table__expand-icon--active': data.isExpanded,
                  },
                  on: {
                    click: (e) => {
                      e.stopPropagation()
                      data.expand(!data.isExpanded)
                    },
                  },
                },
                [this.expandIcon]
              )
      }

      return this.$createElement(Row, {
        key: getObjectValueByPath(item, this.itemKey),
        class: mergeClasses(
          { ...classes, 'v-data-table__selected': data.isSelected },
          getPropertyFromItem(item, this.itemClass)
        ),
        props: {
          headers: this.computedHeaders,
          hideDefaultHeader: this.hideDefaultHeader,
          index,
          item,
          rtl: this.$vuetify.rtl,
        },
        scopedSlots,
        on: {
          // TODO: for click, the first argument should be the event, and the second argument should be data,
          // but this is a breaking change so it's for v3
          click: () => this.$emit('click:row', item, data),
          contextmenu: (event) => this.$emit('contextmenu:row', event, data),
          dblclick: (event) => this.$emit('dblclick:row', event, data),
        },
      })
    },

    genHeaders(props) {
      const data = {
        props: {
          ...this.sanitizedHeaderProps,
          headers: this.computedHeaders,
          options: props.options,
          mobile: this.isMobile,
          showGroupBy: this.showGroupBy,
          checkboxColor: this.checkboxColor,
          someItems: this.someItems,
          everyItem: this.everyItem,
          singleSelect: this.singleSelect,
          disableSort: this.disableSort,
        },
        on: {
          sort: props.sort,
          group: props.group,
          'toggle-select-all': this.toggleSelectAll,
        },
      } // TODO: rename to 'head'? (thead, tbody, tfoot)

      const children = [getSlot(this, 'header', { ...data, isMobile: this.isMobile })]

      if (!this.hideDefaultHeader) {
        const scopedSlots = getPrefixedScopedSlots('header.', this.$scopedSlots)
        children.push(this.$createElement(EDataTableHeader, { ...data, scopedSlots }))
      }

      // if (this.loading) children.push(this.genLoading())
      return children
    },
    genFooters(props) {
      const data = {
        props: {
          options: props.options,
          pagination: props.pagination,
          itemsPerPageText: '$vuetify.dataTable.itemsPerPageText',
          ...this.sanitizedFooterProps,
        },
        on: {
          'update:options': (value) => props.updateOptions(value),
        },
        widths: this.widths,
        headers: this.computedHeaders,
      }
      const children = [getSlot(this, 'footer', data, true)]

      if (!this.hideDefaultFooter) {
        children.push(
          this.$createElement(EDataFooter, {
            ...data,
            scopedSlots: getPrefixedScopedSlots('footer.', this.$scopedSlots),
          })
        )
      }

      return children
    },
    genDefaultScopedSlot(props) {
      const simpleProps = {
        height: this.height,
        fixedHeader: this.fixedHeader,
        dense: this.dense,
      } // if (this.virtualRows) {
      //   return this.$createElement(VVirtualTable, {
      //     props: Object.assign(simpleProps, {
      //       items: props.items,
      //       height: this.height,
      //       rowHeight: this.dense ? 24 : 48,
      //       headerHeight: this.dense ? 32 : 48,
      //       // TODO: expose rest of props from virtual table?
      //     }),
      //     scopedSlots: {
      //       items: ({ items }) => this.genItems(items, props) as any,
      //     },
      //   }, [
      //     this.proxySlot('body.before', [this.genCaption(props), this.genHeaders(props)]),
      //     this.proxySlot('bottom', this.genFooters(props)),
      //   ])
      // }

      return this.$createElement(
        VSimpleTable,
        {
          props: simpleProps,
          class: {
            'e-data-table': true,
            'e-data-table--mobile': this.isMobile,
            // 'v-data-table--mobile': this.isMobile,
          },
        },
        [
          this.proxySlot('top', getSlot(this, 'top', { ...props, isMobile: this.isMobile }, true)),
          this.genCaption(props),
          this.genColgroup(props),
          this.genHeaders(props),
          this.genBody(props),
          this.genFoot(props),
          this.proxySlot('bottom', this.genFooters(props)),
        ]
      )
    },
  },
}
</script>
